
<!-- Auftragsstatus + optionale Suche -->
<div class="top-bar">
  <div class="order-status" [class.has-order]="!!currentOrderTitle">
    <ion-icon [name]="currentOrderTitle ? 'cart-outline' : 'alert-circle-outline'" class="status-icon"></ion-icon>
    <span class="status-text">{{ currentOrderTitle ? (currentOrderTitle | slice:0:15) : 'Kein Auftrag' }}</span>
  </div>
  <ng-container *ngIf="showSearch">
    <ion-searchbar
      [ngModel]="searchTerm"
      (ionInput)="onSearchChange($event)"
      placeholder="Suche..."
      class="inline-search">
    </ion-searchbar>
    <button *ngIf="scannerSupported" class="icon-tool-btn" (click)="scanBarcode()">
      <ion-icon name="barcode-outline"></ion-icon>
    </button>
  </ng-container>
</div>

<!-- Filter-Bar: kompakt, eine Zeile -->
<div class="filter-bar">
  <button class="filter-icon-btn" [class.active]="showRecentOnly" (click)="toggleRecentFilter()" title="Zuletzt verwendet">
    <ion-icon name="time-outline"></ion-icon>
  </button>
  <button class="filter-icon-btn" [class.active]="showFavoritesOnly" (click)="toggleFavoritesFilter()" title="Nur Favoriten">
    <ion-icon [name]="showFavoritesOnly ? 'star' : 'star-outline'"></ion-icon>
  </button>
  <button class="filter-icon-btn" [class.active]="showInOrderOnly" (click)="toggleInOrderFilter()" title="Im Warenkorb">
    <ion-icon name="cart-outline"></ion-icon>
  </button>
  <button class="filter-icon-btn" *ngIf="scanHistory.length > 0" [class.active]="showScanHistoryOnly" (click)="toggleScanHistoryFilter()" title="Zuletzt gescannt">
    <ion-icon name="scan-outline"></ion-icon>
  </button>
  <button class="filter-icon-btn" *ngIf="isAdmin" [class.active]="showKarmaUnavailableOnly" (click)="toggleKarmaUnavailableFilter()" title="Nicht bei Karma verfügbar">
    <ion-icon name="alert-circle-outline"></ion-icon>
  </button>

  <div class="filter-divider"></div>

  <!-- Aktive Filter als kleine Chips (nur wenn gesetzt) -->
  <button *ngFor="let s of selectedSeasonsArray" class="active-chip" (click)="toggleSeason(s)">
    {{ s }} <ion-icon name="close-outline"></ion-icon>
  </button>
  <button *ngFor="let sz of selectedSizesArray" class="active-chip" (click)="toggleSize(sz)">
    {{ sz }} <ion-icon name="close-outline"></ion-icon>
  </button>
  <button *ngFor="let m of selectedMaterialsArray" class="active-chip" (click)="toggleMaterial(m)">
    {{ m }} <ion-icon name="close-outline"></ion-icon>
  </button>
  <!-- Farbfilter-Chips: noch nicht aktiviert -->

  <div class="filter-spacer"></div>

  <!-- Filter-Button mit Badge -->
  <button class="filter-open-btn" [class.has-filters]="activeFilterCount > 0" (click)="openFilterSheet()">
    <ion-icon name="options-outline"></ion-icon>
    <span *ngIf="activeFilterCount > 0" class="filter-badge">{{ activeFilterCount }}</span>
  </button>
</div>


<!-- Leer-State -->
<div *ngIf="productList.length && !productRows.length" class="empty-list">
  <ion-icon name="search-outline"></ion-icon>
  <span>Keine Produkte gefunden</span>
</div>

<!-- Virtual Scroll Kompakt-Liste -->
<cdk-virtual-scroll-viewport
  *ngIf="productRows.length"
  itemSize="160"
  minBufferPx="640"
  maxBufferPx="1280"
  class="product-scroll-viewport"
  (scrolledIndexChange)="prefetchVisibleThumbs()">

  <div class="product-row" [class.in-order]="row.inCurrentOrder" *cdkVirtualFor="let row of productRows; trackBy: trackByRow">

    <!-- Thumbnail -->
    <div class="thumb-wrap" (click)="row.model[0].images && row.model[0].images[0] && openLightbox(row.model[0].images, 0)">

      <!-- Bilder aktiviert + geladen -->
      <img
        *ngIf="imagesEnabled && row.thumbUrl"
        [src]="row.thumbUrl"
        class="thumb-img"
        alt=""
      />

      <!-- Bilder aktiviert aber noch ladend → Skeleton -->
      <div *ngIf="imagesEnabled && !row.thumbUrl && row.model[0].images && row.model[0].images[0] && !row.thumbLoading"
           class="thumb-placeholder skeleton"
           (mouseenter)="loadThumb(row)">
        <ion-icon name="image-outline"></ion-icon>
      </div>

      <!-- Bilder deaktiviert ODER kein Bild vorhanden → Shirt-Placeholder -->
      <div *ngIf="!imagesEnabled || !row.model[0].images || !row.model[0].images[0]"
           class="thumb-placeholder">
        <ion-icon name="shirt-outline"></ion-icon>
      </div>

    </div>

    <!-- Info-Block -->
    <div class="row-info" (click)="toggleExpand(row, $event)">

      <div class="row-name">
        {{ row.model[0].name }}
        <span *ngIf="showNameDe && row.model[0].nameDe && row.model[0].nameDe !== row.model[0].name"
              class="name-de">{{ row.model[0].nameDe }}</span>
      </div>

      <div class="row-meta">
        <span class="badge season" *ngIf="row.model[0].season">{{ row.model[0].season }}</span>
        <span class="badge model-key">{{ row.model[0].model }}</span>
        <span class="badge company" *ngIf="row.model[0].company">{{ row.model[0].company }}</span>
        <span class="badge recent" *ngIf="isRecentlyUsed(row.model[0].model)">
          <ion-icon name="time-outline"></ion-icon>
        </span>
        <span class="badge in-order-badge" *ngIf="row.inCurrentOrder">
          <ion-icon name="cart-outline"></ion-icon> Im Auftrag
        </span>
      </div>

      <!-- Farben -->
      <div class="row-colors">
        <div class="color-row" *ngFor="let item of row.model; trackBy: trackByColor" [class.karma-unavail-dimmed]="item.karmaUnavailable">
          <img
            *ngIf="item.colorcard && !item['_imgError']"
            [src]="proxyUrl(item.colorcard)"
            class="color-dot img"
            (error)="item['_imgError'] = true"
          />
          <span
            *ngIf="!item.colorcard || item['_imgError']"
            class="color-dot"
            [style.background]="colorHexFallback(item)">
          </span>
          <span class="color-label">
            {{ (item.colorname || item.color).toUpperCase() }}<span class="color-code" *ngIf="item.colorCode">&nbsp;#{{ item.colorCode }}</span><ng-container *ngIf="showTranslations && item.colorDe">&nbsp;<span class="color-label-de">({{ item.colorDe.toUpperCase() }})</span></ng-container>
          </span>
          <app-karma-unavailable-badge
            *ngIf="item.karmaUnavailable && showKarmaUnavailableBadgeInList"
            [unavailable]="true"
            [since]="item.karmaUnavailableSince ?? null"
            [model]="item.model"
            [colorname]="item.colorname || item.color || ''">
          </app-karma-unavailable-badge>
        </div>
      </div>

      <!-- Größen -->
      <div class="row-sizes">
        <span *ngFor="let sz of row.model[0].sizes; trackBy: trackBySize" class="size-chip">{{ sz.size }}</span>
      </div>

      <!-- Dauerhaft sichtbar wenn Einstellung aktiv -->
      <div class="row-desc" *ngIf="showDescription && row.model[0].description">{{ row.model[0].description }}</div>
      <div class="expand-material" *ngIf="showComposition && (row.model[0].materialDe?.length || row.model[0].material?.length)">
        <span class="mat-chip" *ngFor="let m of (row.model[0].materialDe?.length ? row.model[0].materialDe : row.model[0].material)">
          {{ m.value }}% {{ m.key.toUpperCase() }}<ng-container *ngIf="m.name && m.name !== m.key.toUpperCase()"> ({{ m.name }})</ng-container>
        </span>
      </div>

      <!-- Expandierter Bereich -->
      <div class="expand-section" *ngIf="row.expanded">
        <div class="expand-desc" *ngIf="row.model[0].description && !showDescription">{{ row.model[0].description }}</div>
        <div class="expand-cats" *ngIf="row.model[0].categories?.length">
          <span class="cat-chip" *ngFor="let cat of row.model[0].categories">{{ cat }}</span>
        </div>
        <div class="expand-material" *ngIf="!showComposition && (row.model[0].materialDe?.length || row.model[0].material?.length)">
          <span class="mat-chip" *ngFor="let m of (row.model[0].materialDe?.length ? row.model[0].materialDe : row.model[0].material)">
            {{ m.value }}% {{ m.key.toUpperCase() }}<ng-container *ngIf="m.name && m.name !== m.key.toUpperCase()"> ({{ m.name }})</ng-container>
          </span>
        </div>
        <div class="expand-barcodes" *ngIf="row.model[0].barcodes?.length">
          <ion-icon name="barcode-outline" class="bc-icon"></ion-icon>
          <span *ngFor="let b of row.model[0].barcodes" class="bc-chip">{{ b.barcode }}</span>
        </div>
        <!-- Alle Farben mit Preis bei verschiedenen Preisen -->
        <div *ngIf="!row.samePrice" class="expand-prices">
          <div *ngFor="let item of row.model; trackBy: trackByColor" class="price-row">
            <span class="color-dot sm" [style.background]="item.colorHex || '#ccc'"></span>
            <span class="faded-sm">{{ item.colorDe || item.colorname }}<span *ngIf="item.colorCode"> · {{ item.colorCode }}</span></span>
            <span class="price-sm">{{ item.price | number:'1.2-2' }} €</span>
          </div>
        </div>
      </div>

    </div>

    <!-- Rechts: Preis + Aktionen -->
    <div class="row-right">

      <div class="row-price">
        <span *ngIf="row.samePrice && row.model[0].price">{{ row.priceDisplay }}</span>
        <span *ngIf="!row.samePrice" class="multi-price">ab {{ row.model[0].price | number:'1.2-2' }} €</span>
        <span *ngIf="!row.model[0].price" class="na">–</span>
      </div>

      <div class="row-btns">
        <!-- Schnellmengen (nur wenn eine Größe und Auftrag offen) -->
        <div class="quick-qty" *ngIf="row.quickQty !== null">
          <button class="qty-btn" (click)="decrementQuickQty(row, $event)">
            <ion-icon name="remove-outline"></ion-icon>
          </button>
          <span class="qty-val">{{ row.quickQty }}</span>
          <button class="qty-btn" (click)="incrementQuickQty(row, $event)">
            <ion-icon name="add-outline"></ion-icon>
          </button>
        </div>

        <!-- Favorit -->
        <button class="icon-btn fav-btn" (click)="toggleFavorite(row.model[0].model, $event)">
          <ion-icon [name]="isFavorite(row.model[0].model) ? 'star' : 'star-outline'"
                    [class.is-fav]="isFavorite(row.model[0].model)"></ion-icon>
        </button>

        <!-- Hinzufügen: immer sichtbar wenn kein Quick-Qty (kein Auftrag → ActionSheet).
             Bei abgeschlossenem Auftrag ausgegraut; bewusst nicht [disabled],
             damit der Klick den erklärenden Toast auslösen kann. -->
        <button *ngIf="row.quickQty === null"
                class="icon-btn add-btn"
                [class.is-locked]="!canAddProducts && !!currentOrderExists"
                (click)="addProduct(row.model)">
          <ion-icon name="add-circle-outline"></ion-icon>
        </button>
      </div>

      <!-- Admin Profit -->
      <div *ngIf="adminMode && row.samePrice && row.model[0].price" class="admin-profit">
        +{{ (row.model[0].price || 0) - ((row.model[0].cost || 0) * (1 + costDiscount)) | number:'1.2-2' }} €
      </div>

    </div>

  </div>

</cdk-virtual-scroll-viewport>
